import { _ as _extends } from '../../_rollupPluginBabelHelpers-mO86zOh3.js';
import { forwardRef } from 'react';
import { jsx } from '@emotion/react';
import { InteractiveListGroup } from '../InteractiveList/InteractiveListGroup.js';
import '@indeed/ifl-css';
import '@indeed/ihl-use-id';
import '../Box/Box.js';

const OptionGroup = /*#__PURE__*/forwardRef((props, ref) => {
  const {
    children,
    label,
    ...remainingProps
  } = props;
  return jsx(InteractiveListGroup, _extends({
    ref: ref,
    header: label
  }, remainingProps), children);
});
OptionGroup.displayName = "OptionGroup";

export { OptionGroup };
